import { dataLocationCopySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLocationCopySolid = /*#__PURE__*/createIcon(dataLocationCopySolid)
export default IconLocationCopySolid
